import { motion } from "framer-motion";
import { Snowflake, Trash2, Info, ShieldCheck } from "lucide-react";

import Seo from "../../Components/SEO/Seo";
import Container from "../../Components/Container/Container";

import "../../Style/resources/privacy.css";

const PRIVACY_ITEMS = [
  {
    icon: Snowflake,
    title: "Right To Know",
    desc: "We will provide the requested information free of charge up to two times within a 12-month period.",
  },
  {
    icon: Trash2,
    title: "Right To Delete",
    desc: "We will also instruct our service providers to delete your personal data subject to restrictions imposed by the CCPA. This request can be fulfilled by deleting or anonymizing certain information as permitted by the CCPA.",
  },
  {
    icon: Info,
    title: "Do Not Sell My Information",
    desc: "If you wish for us to retain your Personal Information, but do not want us to sell your Personal Information.",
  },
];

export default function Privacy() {
  return (
    <div className="privacy-page">
      <Seo
        title="Data Privacy | Conectify Tech"
        description="With Conectify Tech, Your Data is Always Safe. Learn about your Right To Know, Right To Delete, and Do Not Sell My Information options."
      />

      {/* Top Breadcrumb / Hero Header Banner */}
      <section className="privacy-banner">
        <Container>
          <div className="privacy-banner__content">
            <span className="privacy-banner__tag">
              <ShieldCheck size={14} /> Data Privacy & Governance
            </span>
            <h1 className="privacy-banner__title">Data Privacy</h1>
          </div>
        </Container>
      </section>

      {/* Main Section */}
      <section className="privacy-body">
        <Container>
          <motion.div
            className="privacy-heading text-center"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45 }}
          >
            <h2>
              With <span className="text-gradient">Conectify Tech</span>, Your Data is Always Safe
            </h2>
          </motion.div>

          <div className="privacy-grid">
            {PRIVACY_ITEMS.map((item, idx) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={item.title}
                  className="privacy-card"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: idx * 0.1 }}
                >
                  <div className="privacy-card__icon-box">
                    <Icon size={32} strokeWidth={2.2} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </Container>
      </section>
    </div>
  );
}